var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calendar"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19 4H18V3C18 2.4 17.6 2 17 2C16.4 2 16 2.4 16 3V4H8V3C8 2.4 7.6 2 7 2C6.4 2 6 2.4 6 3V4H5C3.3 4 2 5.3 2 7V8H22V7C22 5.3 20.7 4 19 4ZM2 19C2 20.7 3.3 22 5 22H19C20.7 22 22 20.7 22 19V10H2V19ZM17 12C17.6 12 18 12.4 18 13C18 13.6 17.6 14 17 14C16.4 14 16 13.6 16 13C16 12.4 16.4 12 17 12ZM17 16C17.6 16 18 16.4 18 17C18 17.6 17.6 18 17 18C16.4 18 16 17.6 16 17C16 16.4 16.4 16 17 16ZM12 12C12.6 12 13 12.4 13 13C13 13.6 12.6 14 12 14C11.4 14 11 13.6 11 13C11 12.4 11.4 12 12 12ZM12 16C12.6 16 13 16.4 13 17C13 17.6 12.6 18 12 18C11.4 18 11 17.6 11 17C11 16.4 11.4 16 12 16ZM7 12C7.6 12 8 12.4 8 13C8 13.6 7.6 14 7 14C6.4 14 6 13.6 6 13C6 12.4 6.4 12 7 12ZM7 16C7.6 16 8 16.4 8 17C8 17.6 7.6 18 7 18C6.4 18 6 17.6 6 17C6 16.4 6.4 16 7 16Z",
    fill: "#971EFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.69a7857af1b89baeb73ae47d6602d8c7.svg";
export { ForwardRef as ReactComponent };